export default __webpack_public_path__ + "static/media/chaise-rectangle-1-break.311e5bf8.webp";